document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('[data-td-menu-toggle]');
  const nav = document.querySelector('[data-td-nav]');
  if (!toggle || !nav) return;

  function setOpen(isOpen) {
    nav.classList.toggle('nav--open', isOpen);
    toggle.setAttribute('aria-expanded', String(isOpen));
  }

  toggle.addEventListener('click', function () {
    setOpen(!nav.classList.contains('nav--open'));
  });

  // Close the mobile menu with Escape, returning focus to the toggle.
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && nav.classList.contains('nav--open')) {
      setOpen(false);
      toggle.focus();
    }
  });
});
